import { endpoints } from "consts";
import { generateRequestUrl } from "helpers/dataHelpers";
import { UrlQueryParams } from "types/common";

export const reportsUrlBuilder = {
  getReports: ({ query }: { query: UrlQueryParams }): string => {
    return generateRequestUrl(endpoints.reports, query);
  },
};
